import { render, staticRenderFns } from "./user_portrait.vue?vue&type=template&id=2d74f4ce&scoped=true&"
import script from "./user_portrait.vue?vue&type=script&lang=js&"
export * from "./user_portrait.vue?vue&type=script&lang=js&"
import style0 from "./user_portrait.vue?vue&type=style&index=0&id=2d74f4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d74f4ce",
  null
  
)

export default component.exports